import React, { MouseEvent, useEffect, useRef } from 'react';

import { ReactComponent as CloseIcon } from '../../assets/x.svg';
import { LoginForm } from '../login-form';
import {
	closeButton as closeButtonStyle,
	container as containerStyle,
	dialogContainer as dialogContainerStyle,
} from './styles.module.css';

export interface LoginFormModalProps {
	open: boolean;
	onLogin(username: string, password: string): Promise<void>;
	onResetPassword(username: string): Promise<void>;
	onClose(): void;
}

export const LoginFormModal = ({
	open,
	onLogin,
	onResetPassword,
	onClose,
}: LoginFormModalProps): JSX.Element => {
	const dialogRef = useRef<HTMLDialogElement>(null);

	useEffect(() => {
		if (open) {
			handleOpenDialog();
		}
	}, [open]);

	const handleOpenDialog = () => {
		// These techniques to stop background scrolling taken from https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
		// If they break something, look there for other body styles that can be manipulated (such as padding-right and position: fixed
		// for mobile)
		document.body.style.height = '100vh';
		document.body.style.overflowY = 'hidden';
		dialogRef.current?.showModal();
	};

	const closeDialog = () => {
		document.body.style.height = '';
		document.body.style.overflowY = '';
		dialogRef.current?.close();
		onClose();
	};

	const handleOnCloseDialog = () => closeDialog();

	const handleOnClickDialog = (event: MouseEvent<HTMLDialogElement>) => {
		// If the target is not the dialog, the click is inside the div and should be ignored
		if (event.target !== dialogRef.current) return;

		closeDialog();
	};

	const handleOnLogin = (username: string, password: string) => onLogin(username, password);
	const handleResetPassword = (username: string) => onResetPassword(username);

	return (
		<div className={containerStyle}>
			<dialog ref={dialogRef} onClick={handleOnClickDialog}>
				<div className={closeButtonStyle} onClick={handleOnCloseDialog}>
					<CloseIcon />
				</div>
				<div className={dialogContainerStyle}>
					<LoginForm
						onLogin={handleOnLogin}
						onResetPassword={handleResetPassword}
						onClose={handleOnCloseDialog}
					/>
				</div>
			</dialog>
		</div>
	);
};
